export default __webpack_public_path__ + "static/media/hostImgAg2.e6503d08.jpg";